module.exports = __webpack_public_path__ + "img/DK32049664.9a760ec4.png";